// extracted by mini-css-extract-plugin
module.exports = {"page":"menu_page__3W11r","menu-column":"menu_menu-column__31DQt"};